// import gsap from 'gsap'
import './priceTable.css'
import { bp, mm, onDomReady, sel, selAll, stResizeObserver } from '../utils'
// import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)
export default function PriceTable() {
  const tableW$ = sel('.price-table-w.is--v1')

  if (!tableW$) return
  console.log('table$ v1', tableW$)

  // Table Tabs
  window.addEventListener('load', function () {
    // return
    // console.log('priceTable.js loaded')
    //
    const initPlan = tableW$.getAttribute('data-wf--price-table--variant') || 'apex'
    console.log('initPlan', initPlan)

    const tableCoreVariant = 'w-variant-c8859ff5-c597-aa2d-97f6-59f00768b768'
    const tableApexVariant = 'w-variant-69ecb1bc-b68c-f2e9-c478-f1da121db5e1'
    const tableEpicVariant = 'w-variant-a7cf462b-1df3-77bc-708c-898985446a92'

    const headerCoreVariant = 'w-variant-5b146329-b564-3cc4-693d-965ec61bce42'
    const headerApexVariant = 'w-variant-52fdd623-29ec-b8a8-aa5e-fd4e99f7f3e2'
    const headerEpicVariant = 'w-variant-89a01dda-5fb5-83fa-306c-ac5e757577f0'

    const dataCoreVariant = 'w-variant-54800915-d893-0cfb-0438-0aeef23b9abe'
    const dataApexVariant = 'w-variant-ea03cc85-eb2c-240e-c365-90f73cc91be1'
    const dataEpicVariant = 'w-variant-aec6b67c-00db-161f-4569-16ca419e9966'

    const footerCoreVariant = 'w-variant-32bb277d-52ed-c2cf-aab7-9525586c1791'
    const footerApexVariant = 'w-variant-3f1353ac-abf4-17cd-237d-59603c96e86a'
    const footerEpicVariant = 'w-variant-14998586-e9cf-db32-a3a4-ae6cce6383f6'

    const header$a = selAll('.price-table__col.is--header')
    const col2to4$a = selAll('.price-table__col:not(.is--1)')
    const footer$a = selAll('.price-table__col.is--footer')

    const col1Cell$a = selAll('.price-table__row > :nth-child(4n + 1)')
    const col2Cell$a = selAll('.price-table__row > :nth-child(4n + 2)')
    const col3Cell$a = selAll('.price-table__row > :nth-child(4n + 3)')
    const col4Cell$a = selAll('.price-table__row > :nth-child(4n + 4)')

    const col2DataCell$a = selAll('.price-table__row > :nth-child(4n + 2).is--data')
    const col3DataCell$a = selAll('.price-table__row > :nth-child(4n + 3).is--data')
    const col4DataCell$a = selAll('.price-table__row > :nth-child(4n + 4).is--data')
    // console.log('col2Data', col2to4$a)

    function removeVariantClasses() {
      const targets = [tableW$, ...header$a, ...col2DataCell$a, ...col3DataCell$a, ...col4DataCell$a, ...footer$a]
      targets.forEach((el) => {
        ;[...el.classList].forEach((cls) => {
          if (cls.startsWith('w-variant')) el.classList.remove(cls)
        })
      })
    }
    function addVariantClasses(col = 4) {
      switch (col) {
        case 2:
          tableW$.classList.add(tableCoreVariant)
          header$a[0].classList.add(headerCoreVariant)
          col2DataCell$a.forEach((cell) => cell.classList.add(dataCoreVariant))
          footer$a[0].classList.add(footerCoreVariant)
          break
        case 3:
          tableW$.classList.add(tableApexVariant)
          header$a[1].classList.add(headerApexVariant)
          col3DataCell$a.forEach((cell) => cell.classList.add(dataApexVariant))
          footer$a[1].classList.add(footerApexVariant)

          break
        case 4:
          tableW$.classList.add(tableEpicVariant)
          header$a[2].classList.add(headerEpicVariant)
          col4DataCell$a.forEach((cell) => cell.classList.add(dataEpicVariant))
          footer$a[2].classList.add(footerEpicVariant)
          break
      }
    }

    // console.log('Class attribute changed:', classList)
    // Determine currently applied table variant (if any)
    // const activeVariant = Array.from(table$.classList).find((c) => c.startsWith('w-variant-')) || tableApexVariant
    // const activeVariant = Array.from(tableW$.classList).find((c) => c.startsWith('w-variant'))
    // console.log('activeVariant', activeVariant)

    // Always normalize classes based on the detected/default variant
    console.log('initPlan', initPlan)
    removeVariantClasses()
    if (initPlan === 'core') addVariantClasses(2)
    else if (initPlan === 'apex') addVariantClasses(3)
    else addVariantClasses(4)

    mm.add(bp.deskUp, () => {
      ;[col2Cell$a, col3Cell$a, col4Cell$a].forEach((col, i) => {
        const index = i + 2
        col.forEach((cell) => {
          cell.addEventListener('mouseenter', function () {
            // console.log('yo', i)
            removeVariantClasses()
            addVariantClasses(index)
          })
        })
      })
    })

    mm.add(bp.tabDown, () => {
      // Table
      header$a.forEach((tab$) => {
        const tabColClass = tab$.dataset.col
        // console.log('tabColClass', tabColClass)

        tab$.addEventListener('click', function () {
          // console.log('tabColClass', tabColClass)
          header$a.forEach((tab$) => {
            if (this === tab$) return

            const colNum = [...this.parentElement.children].indexOf(this)
            // console.log('colNum', colNum)
            removeVariantClasses()
            addVariantClasses(colNum + 1)
          })
        })

        // if (tab$.classList.contains('is--active')) tab$.click()
      })
    })

    // Desk Animation
    mm.add(bp.tabUp, () => {
      const rowTw = {
        // x: 10,
        autoAlpha: 0,
        stagger: 0.125,
        ease: 'power1.out',
      }
      const tableTl = gsap
        .timeline({ defaults: { ease: 'none', duration: 1 } })
        .from(col1Cell$a, rowTw, 0)
        .from(col2Cell$a, rowTw, 0)
        .from(col3Cell$a, rowTw, 0)
        .from(col4Cell$a, rowTw, 0)

      ScrollTrigger.create({
        trigger: tableW$,
        start: 'top 80%',
        toggleActions: 'play none none reverse',
        // markers: true,
        animation: tableTl,
      })
    })
  })
  stResizeObserver()
}
